import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { Action, createReducer, on } from '@ngrx/store';
import { LandingPageEntity } from '../../models/landing-page.entities';
import * as LandingPageActions from '../actions/landing-page.actions';

export const LANDING_PAGE_FEATURE_KEY = 'landingPage';

export interface State extends EntityState<LandingPageEntity> {
  loaded: boolean; // has the SkyMiles list been loaded
  error?: string | null; // last known error (if any)
}

export const landingPageAdapter: EntityAdapter<LandingPageEntity> =
  createEntityAdapter<LandingPageEntity>();

export const initialState: State = landingPageAdapter.getInitialState({
  loaded: false
});

const landingPageReducer = createReducer(
  initialState,
  on(LandingPageActions.loadAEMMedallionBanner, (state) => ({
    ...state,
    loaded: false,
    error: null
  })),
  on(
    LandingPageActions.loadAEMMedallionBannerSuccess,
    (state, { aemMedallionBannerContent }) =>
      landingPageAdapter.setOne(aemMedallionBannerContent, {
        ...state,
        loaded: true
      })
  ),
  on(
    LandingPageActions.loadAEMMedallionBannerFailure,
    (state, { aemErrorContent }) =>
      landingPageAdapter.setOne(aemErrorContent, {
        ...state,
        loaded: true
      })
  ),
  on(LandingPageActions.loadAEMMenuSuccess, (state, { aemMenuContent }) =>
    landingPageAdapter.setOne(aemMenuContent, {
      ...state,
      loaded: true
    })
  ),
  on(LandingPageActions.loadAEMMenuFailure, (state, { aemMenuErrorContent }) =>
    landingPageAdapter.setOne(aemMenuErrorContent, {
      ...state,
      loaded: true
    })
  ),
  on(
    LandingPageActions.loadAEMFeatureFlagsSuccess,
    (state, { aemFeatureFlags }) =>
      landingPageAdapter.setOne(aemFeatureFlags, {
        ...state,
        loaded: true
      })
  ),
  on(
    LandingPageActions.loadAEMFeatureFlagsFailure,
    (state, { aemFeatureFlagsError }) =>
      landingPageAdapter.setOne(aemFeatureFlagsError, {
        ...state,
        loaded: true
      })
  ),
  on(
    LandingPageActions.loadAEMErrorMessagesSuccess,
    (state, { aemErrorMessages }) =>
      landingPageAdapter.setOne(aemErrorMessages, {
        ...state,
        loaded: true
      })
  ),
  on(
    LandingPageActions.loadAEMErrorMessagesFailure,
    (state, { aemErrorMessagesError }) =>
      landingPageAdapter.setOne(aemErrorMessagesError, {
        ...state,
        loaded: true
      })
  ),
  on(
    LandingPageActions.loadBusinessTravelerFeatureFlagSuccess,
    (state, { aemBusinessTravelerFeatureFlag }) =>
      landingPageAdapter.setOne(aemBusinessTravelerFeatureFlag, {
        ...state,
        loaded: true
      })
  ),
  on(
    LandingPageActions.loadBusinessTravelerFeatureFlagFailure,
    (state, { aemBusinessTravelerFeatureFlagError }) =>
      landingPageAdapter.setOne(aemBusinessTravelerFeatureFlagError, {
        ...state,
        loaded: true
      })
  ),
  on(
    LandingPageActions.loadBusinessTravelerContentSuccess,
    (state, { businessTraveler }) =>
      landingPageAdapter.setOne(businessTraveler, {
        ...state,
        loaded: true
      })
  ),
  on(
    LandingPageActions.loadBusinessTravelerContentFailure,
    (state, { businessTravelerError }) =>
      landingPageAdapter.setOne(businessTravelerError, {
        ...state,
        loaded: true
      })
  )
);

export const reducer = (state: State | undefined, action: Action) =>
  landingPageReducer(state, action);
